module.exports = __webpack_public_path__ + "static/media/background.a1012231.jpg";